<template>
  <div>
    <div class="w-full">
      <template v-for="(item, i) in tableList">
        <div :key="i" class="w-full" >
          <div class="flex">
            <div class="p-2 border border-gray-300 w-1/2">
              {{ item.a }}
            </div>
            <div class="p-2 border border-gray-300 w-1/2">
              {{ item.b }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: ["tableList"],
};
</script>